import { Appl } from '../../../core/Appl';
import DeathReportViewModel from './addEdit/DeathReportViewModel';
import { DeathReportService } from './DeathReportService';


export default class DeathReportModule {

    public static init(): void {
        Appl.Services.add('IDeathReportService', DeathReportService);
        Appl.Services.add('DeathReportViewModel', DeathReportViewModel);
    }
}
